import React, { ReactElement } from 'react';

interface FAQElement {
  title: string;
  body: ReactElement;
}

type FAQs = FAQElement[];

export const faq: FAQs = [
  {
    title: 'How do I get started with Be.Live? ',
    body: (
      <>
        <p>1. Click Start free trial or Sign Up</p>
        <p>2. Fill in your email and password, or select Facebook or Google as your sign-up method</p>
        <p>
          3. After signing up, you will be directed to the broadcasting studio, where you can start
          or schedule a show. Learn how to go live{' '}
          <a target='_blank' href='https://help.be.live/en/destinations/how-to-go-live-on-facebook'>
            here
          </a>
        </p>
      </>
    ),
  },
  {
    title: 'Can I test the platform before upgrading to a paid plan?',
    body: (
      <p>
        Sure! We offer 14 days of free trial to all our new users. Once the trial ends, you will be
        automatically downgraded to the free plan.
      </p>
    ),
  },
  {
    title: 'Can I cancel my subscription at any time?',
    body: (
      <>
        <p>
          Yes! Once you cancel the paid subscription, you won't be charged again unless you
          re-subscribe.
        </p>
        <p>
          For any further questions, contact our Support Team through{' '}
          <a target='_blank' href='https://be.live/?contact_support=true'>
            chat
          </a>{' '}
          or email us at <a href='mailto:team@be.live'>team@be.live</a>
        </p>
      </>
    ),
  },
  {
    title: 'What is the refund policy?',
    body: (
      <>
        <p>
          According to our{' '}
          <a target='_blank' href='https://belive.tv/tos'>
            Terms of Service
          </a>{' '}
          ("Cancellation/Refund Policy"), you may receive a refund during the cooling-off period
          (up to 14 days after purchase if you haven’t used the platform).
        </p>
        <p>
          Full details here:{' '}
          <a
            target='_blank'
            href='https://help.be.live/plans-payments-and-managing-subscriptions/pricing-packages-and-answers-to-financial-questions'
          >
            Pricing Packages and Answers to Financial Questions
          </a>
        </p>

        <p>
          For any further questions, contact our Support Team through{' '}
          <a target='_blank' href='https://be.live/?contact_support=true'>
            chat
          </a>{' '}
          or email us at{' '}
          <a target='_blank' href='mailto:team@be.live'>
            team@be.live
          </a>
          .
        </p>
      </>
    ),
  },
];
